/* eslint-disable @typescript-eslint/naming-convention */

export class UserCredentialsDto {
	public Userid: string;
	public Password: string;
	public Environment?: string;
	public AuthenticationMethod: string;

	public constructor(credentials: Partial<UserCredentialsDto>) {
		this.Userid = credentials.Userid;
		this.Password = credentials.Password;
		this.Environment = credentials.Environment;
		this.AuthenticationMethod = credentials.AuthenticationMethod;
	}
}
